import Modal from 'src/Utils/CssModules/modal.module.css';
import './SubscriptionCancelledDialog.css';

import AuraLaptop from "src/images/AuraLaptop.png";
import Cancel from "src/images/cancel.png";
import { formatSubscriptionEndDate } from 'src/Utils/SubscriptionDateFormatter/SubscriptionDateFormatter';
import { useTranslation } from 'react-i18next';
import PopupDialog from 'src/SharedComponents/PopupDialog/PopupDialog';

interface ISubscriptionCancelledDialog{
    onClose: () => void;
    licenseEndDate: string;
}


const SubscriptionCancelledDialog: React.FC<ISubscriptionCancelledDialog> = ({onClose, licenseEndDate}) => {
    const { t } = useTranslation();

    return(
        <div className='cancelled-subscription-container'>
            <PopupDialog onClose={onClose} popupWidth='440px'>
                <div className='row' style={{marginLeft: '10px', paddingTop: '40px'}}>
                    <div className={Modal.header} style={{ textAlign: 'center', paddingLeft: '0px' }}>
                        <div className='col image-container'>
                            <img src={AuraLaptop} alt="Aura" />
                            <img src={Cancel} alt="Cancel" className="cancel-icon" />
                        </div>

                        <div className='col cancel-subscription'>
                            <span>{t('AuraSubscriptionCancelled')}</span>
                        </div>
                    </div>
                    <div className={Modal.body}>
                        <div className='row' style={{ paddingTop: '10px', textAlign: 'center'}}>
                            <span style={{fontSize: '14px'}}>{t('ConfirmationEmailSent')}</span>
                        </div>
                    </div>

                    <div className='row mb-4 text-center' style={{ paddingTop: '50px'}}>
                        <span style={{fontSize: '14px', color: '#000'}}>{t('AccessUntil', { licenseEndDate: formatSubscriptionEndDate(licenseEndDate) })}</span>
                    </div>
                </div>
            </PopupDialog>
        </div>
    );
}

export default SubscriptionCancelledDialog;